import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { fetchData } from '../../../helpers/methods';
import { formatDateForAgo } from '../../../helpers/date-time';

import SpinnerContainer from '../../../component-library/spinner-container';
import Tile from '../../../component-library/tile';

const NewsProviderUpdates = () => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);

	const getData = () => {
		fetchData({
			uri: '/api/web/news/latest',
			method: 'GET',
		})
			.then(({ ok, body }) => {
				if (ok) {
					const newData = body.notices;
					setData(newData);
					setLoading(false);
				} else {
					setLoading(false);
				}
			})
			.catch(() => {
				setLoading(false);
			});
	};

	useEffect(() => {
		getData();
	}, []);

	return (
		<div>
			{loading && (
				<SpinnerContainer />
			)}
			{!loading && (
				<>
					{data?.length ? (
						data.map((item, index) => (
							// eslint-disable-next-line react/no-array-index-key
							<div className="margin-bottom-16" key={index}>
								<Tile>
									<div className="flex-row justify-space-between align-items-flex-start">
										<h3
											className="text-link"
											onClick={() => navigate(`/catalog/details/${item.itemKey.id}`)}
											role="presentation"
										>
											{item.itemKey.name}
										</h3>
										<div className="grey-text">{formatDateForAgo(item.comment.timestamp)}</div>
									</div>
									<p className="margin-bottom-none">{item.comment.message}</p>
								</Tile>
							</div>
						))
					) : (
						<p className="grey-text">No provider updates available</p>
					)}
				</>
			)}
		</div>
	);
};

export default NewsProviderUpdates;
